<template>
  <div class="xc-box topDiv flex">
    <div class="swiper-box">
      <div class="bswiper">
        <div class="thumbs-box">
          <div id="thumbs">
            <div class="swiper-wrapper">
              <div
                v-for="(item, index) in swiper_img"
                :key="index"
                class="swiper-slide videoNav"
                :class="
                  activeIndex === index ? 'swiper-slide-thumb-active' : ''
                "
              >
                <img :src="item.pic" alt="" />
              </div>
            </div>
          </div>
        </div>

        <div class="center-line">
          <div class="light-line"></div>
        </div>

        <div class="right-swiper-box rightDiv">
          <div class="swiper-container swiper-container-video">
            <div class="swiper-wrapper">
              <div
                v-for="(item, index) in swiper_img"
                :key="index"
                class="swiper-slide"
              >
                <!-- <img :src="item" alt="" /> -->
                <!-- <iframe
                  id="video"
                  :src="item.videoUrl"
                  frameborder="0"
                  class="videobox"
                ></iframe> -->

                <video-player
                  class="video-player vjs-custom-skin videobox"
                  ref="videoPlayerss"
                  :playsinline="true"
                  :options="playerOptions"
                >
                </video-player>
              </div>
            </div>
          </div>
          <!-- 导航按钮 -->
          <div class="swiper-button-prev swiper-button-prev_1"></div>
          <div class="swiper-button-next swiper-button-next_1"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import "swiper/dist/css/swiper.css";
import "swiper/dist/js/swiper.min";
import Swiper from "swiper";
export default {
  components: { videoPlayer },
  computed: {},
  data() {
    return {
      seleIndex: 0,
      list: [],
      xzIndex: 0,
      activeIndex: 0,
      navList: [
        {
          name: "视频监控",
        },
        {
          name: "产业宣传",
        },
      ],
      videoIndex: 0,
      swiper_img: [
        {
          pic: require("images/zhwl/video-pic01.png"),
          videoUrl: window.__config.VUE_APP_IMG_URL + "/upload/mmlz1.mp4",
        },
        {
          pic: require("images/video/video-pic02.png"),
          videoUrl: window.__config.VUE_APP_IMG_URL + "/upload/mmlz2.mp4",
        },
        {
          pic: require("images/video/video-pic03.png"),
          videoUrl: window.__config.VUE_APP_IMG_URL + "/upload/mmlz3.mp4",
        },
        {
          pic: require("images/zhwl/mmlz16.jpg"),
          videoUrl: window.__config.VUE_APP_IMG_URL + "/upload/mmlz16.mp4",
        },
        {
          pic: require("images/zhwl/mmlz17.png"),
          videoUrl: window.__config.VUE_APP_IMG_URL + "/upload/mmlz17.mp4",
        },
        {
          pic: require("images/zhwl/mmlz18.jpg"),
          videoUrl: window.__config.VUE_APP_IMG_URL + "/upload/mmlz18.mp4",
        },
        {
          pic: require("images/zhwl/mmlz4.png"),
          videoUrl: window.__config.VUE_APP_IMG_URL + "/upload/mmlz4.mp4",
        },
      ],
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: true, // 如果为true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 类型
            src: window.__config.VUE_APP_IMG_URL + "/upload/mmlz1.mp4", // url地址
          },
        ],
        // poster: require("images/zhwl/video-pic01.png"), // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initSwiper();
    });
  },
  methods: {
    selClick(index) {
      this.seleIndex = index;
    },
    initSwiper() {
      this.$nextTick(function() {
        this.myswiper = new Swiper(".swiper-container-video", {
          // autoplay: 2500, // 可选选项，自动滑动
          navigation: {
            nextEl: ".swiper-button-next_1",
            prevEl: ".swiper-button-prev_1",
          },
          thumbs: {
            swiper: {
              el: "#thumbs",
              spaceBetween: 10,
              slidesPerView: 3,
              observer: true,
              direction: "vertical",
              watchSlidesVisibility: true /* 避免出现bug*/,
              centeredSlides: false,
            },
          },
          on: {
            slideChange: () => {
              this.activeIndex = this.myswiper.activeIndex;
              this.playerOptions.sources[0].src = this.swiper_img[
                this.activeIndex
              ].videoUrl;
            },
          },
        });
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.side
  position absolute
  bottom 0
  top 105px
  bottom 0
  z-index 9
  width 100%
  background-color rgba(9, 26, 54, 0.8)
  color #fff
  @media (max-width 1366px)
    top 55px
.mainDiv
  width calc(100% - 60px)
  height calc(100% - 20px)
  margin 10px 30px
  font-size 0.06rem
.topDiv
  height calc(100% - 48px)
  width 100%
.botDiv
  height 45px
  width calc(100% - 40px)
  margin 10px 22px 0 18px
  border-top 3px #000102 solid
.flex
  display flex
  align-items center
.leftDiv
  width 20%
  margin-right 18px
  height 100%
  justify-content center
.rightDiv
  width calc(80% - 18px)
  height 100%
  background url('~images/video/bg-video.png') no-repeat center
  background-size 100% 100%
.tops
  position relative
  height calc(100% - 0px)
  width 98%
  margin 0 1%
  overflow hidden
  z-index 9
.videoNav
  background url('~images/video/video_nav.png') no-repeat center
  background-size 100% 100%
.botDiv
  height 45px
  width calc(100% - 40px)
  margin 10px 22px 0 18px
  border-top 3px #000102 solid
.flex
  display flex
  align-items center
.leftDiv
  width 20%
  margin-right 18px
  height 100%
  justify-content center
.rightDiv
  width calc(80% - 18px)
  height 100%
  background url('~images/video/bg-video.png') no-repeat center
  background-size 100% 100%
.botNav
  position relative
  height 100%
  width 0.5rem
  font-size 0.08rem
  justify-content center
  cursor pointer
.lines
  width 100%
  height 2px
  background #3981E0
  position absolute
  top -2.5px
  left 0
.sjx
  position absolute
  top -13px
  left 0px
  width 100%
  height 15px
  justify-content center
.sjx img
  height 100%

.swiper-box
      height 100%
      width 100%
      // margin-top 16px
      .bswiper
        display flex
        width 100%
        height 100%
        padding 0 10px
        box-sizing border-box
        .thumbs-box
          height 100%
          width 20%
          display flex
          align-items center
          #thumbs
            width 100%
            height 100%
            overflow-y auto
            &::-webkit-scrollbar
              width 4px
              background-color #030814
            /* 定义滚动条轨道 内阴影+圆角 */
            &::-webkit-scrollbar-track
              -webkit-box-shadow inset 0 0 6px transparent
              background-color transparent
            /* 定义滑块 内阴影+圆角 */
            &::-webkit-scrollbar-thumb
              border-radius 10px
              -webkit-box-shadow inset 0 0 6px transparent
              background-color #377DC0
            /* 定义最上方和最下方的按钮 */
            &::-webkit-scrollbar-button
              height 0
            .swiper-wrapper
                >>>.swiper-slide
                    width 95%
                    height 30% !important
                    opacity 0.6
                    margin-bottom 10px
                    box-sizing border-box
                    cursor pointer
                    img
                        display block
                        width 80%
                        height 80%
                        margin 6% auto
                        border 2px solid #0e6079
                    // height 62px
                .swiper-slide-thumb-active
                    opacity 1
                .swiper-slide-active
                    opacity 1
        .right-swiper-box
          // width calc(100% - 120px)
          height 100%
          position relative
          display flex
          align-items center
          justify-content center
          margin-left 10px
          // background #041649
          // border-right 4px solid #00aeff
          // border-left 4px solid #00aeff
          .swiper-title
            line-height 40px
            font-size 16px
            text-align center
            color #fff
          .swiper-container
            width 90%
            height 90%
            >>>.swiper-wrapper
                .swiper-slide
                  img
                    width 260px
                    height 190px
          .swiper-button-prev,.swiper-button-next
            width 40px
            height 53px
            margin-top 14px
          .swiper-button-prev:after, .swiper-button-next:after
            display none
          .swiper-button-prev_1
            left 12px
            background url('~images/video/left.png') no-repeat center
            background-size 100% 100%
          .swiper-button-next_1
            right 12px
            background url('~images/video/right.png') no-repeat center
            background-size 100% 100%
  .center-line
    position relative
    width 1px
    height 100%
    background #0559a3
    .light-line
      position absolute
      top 50%
      left 0
      width 1px
      height 97px
      margin-top -48.5px
      background #00aeff
.video-player,.videobox
    width 100%
    height 100%
</style>
<style>
.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
  height: 100% !important;
  padding-top: 0 !important;
  width: 100% !important;
}
.vjs-tech {
  width: 100% !important;
  height: 100% !important;
}
.vjs-poster {
  background-position: center !important;
  background-size: cover !important;
}
.dddd {
  width: calc(100% - 2px) !important;
  height: calc(100% - 2px) !important;
  object-fit: fill;
  border: 1px #31d5f3 solid;
}
video {
  width: calc(100% - 2px) !important;
  height: calc(100% - 2px) !important;
  border: 1px #31d5f3 solid;
}
/* video{
      width: 100% !important;
      height: calc(100vh - 95px) !important;
      object-fit:fill;    //消除留白
} */
</style>
